/**
 * Native Shopify language and country/currency selectors.
 * Manual choices always take priority over automatic suggestions.
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form ? this.form.querySelectorAll(
        'select[name="locale_code"], select[name="country_code"]'
      ) : [];

      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);

      this.inputs.forEach((item) => {
        item.addEventListener('change', () => {
          try {
            window.localStorage.setItem('barocco_localization_manual', '1');
          } catch (error) {
            // Storage can be unavailable in private browsing.
          }
          this.debouncedOnSubmit();
        });
      });
    }

    onSubmitHandler() {
      if (this.form) this.form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);
}

(() => {
  if (window.__baroccoLocalizationAutoInit || window.Shopify?.designMode) return;
  window.__baroccoLocalizationAutoInit = true;

  try {
    if (window.localStorage.getItem('barocco_localization_manual') === '1') return;
    if (window.sessionStorage.getItem('barocco_localization_checked') === '1') return;
    window.sessionStorage.setItem('barocco_localization_checked', '1');
  } catch (error) {
    // Continue without persistence if storage is unavailable.
  }

  const currentCountry = window.Shopify?.country || '';
  const currentLanguage = window.Shopify?.language || window.Shopify?.locale || '';
  const root = window.Shopify?.routes?.root || '/';
  const endpoint =
    root +
    'browsing_context_suggestions.json' +
    '?country[enabled]=true' +
    '&country[exclude]=' + encodeURIComponent(currentCountry) +
    '&language[enabled]=true' +
    '&language[exclude]=' + encodeURIComponent(currentLanguage);

  fetch(endpoint, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then((response) => {
      if (!response.ok) throw new Error('Localization suggestion request failed');
      return response.json();
    })
    .then((data) => {
      const suggestion = data?.suggestions?.[0];
      if (!suggestion) return;

      const countryPart = suggestion.parts?.country;
      const languagePart = suggestion.parts?.language;
      const country =
        countryPart && countryPart.confidence >= 0.9
          ? countryPart.handle
          : currentCountry;
      const language =
        languagePart && languagePart.confidence >= 0.9
          ? languagePart.handle
          : currentLanguage;

      const countryChanged = country && country !== currentCountry;
      const languageChanged = language && language !== currentLanguage;
      if (!countryChanged && !languageChanged) return;

      const form = document.createElement('form');
      form.action = '/localization';
      form.method = 'POST';
      form.hidden = true;

      const method = document.createElement('input');
      method.name = '_method';
      method.value = 'PUT';
      form.appendChild(method);

      if (country) {
        const countryInput = document.createElement('input');
        countryInput.name = 'country_code';
        countryInput.value = country;
        form.appendChild(countryInput);
      }

      if (language) {
        const languageInput = document.createElement('input');
        languageInput.name = 'language_code';
        languageInput.value = language;
        form.appendChild(languageInput);
      }

      document.body.appendChild(form);
      form.submit();
    })
    .catch(() => {
      // Keep the current storefront context when no confident suggestion is available.
    });
})();
